import * as types from './constants';

// Get Stripe Billing
export const getStripeBillingRequest = data => (
  { type: types.GET_STRIPE_BILLING_REQUEST, payload: data }
);

export const getStripeBillingDone = data => (
  { type: types.GET_STRIPE_BILLING_DONE, payload: data }
);

export const getStripeBillingFailed = errors => (
  { type: types.GET_STRIPE_BILLING_FAILED, payload: errors }
);